module.exports = __webpack_public_path__ + "img/6.4b73037c.jpg";